<template>
	<LoginComponent/>
</template>
  
  <script>
import LoginComponent from '@/components/loginviewcompents/LoginComponent.vue';

  
  export default {
	name: 'LoginView',
	data() {
	return {
		password: '',
		username: '',error: ''
	};
	},
	props: {
		
	},
	methods: {
	
	},
	components: {
		LoginComponent
	}
	}
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
	margin: 40px 0 0;
  }
  ul {
	list-style-type: none;
	padding: 0;
  }
  li {
	display: inline-block;
	margin: 0 10px;
  }
  a {
	color: #42b983;
  }
  .logo img{
	width: 220px;
	margin: auto;
	padding: 0;
  }
  </style>
  